import { schema } from 'normalizr';
import activityCategory from './activityCategory';

const challengeTemplateSchema = new schema.Entity('templates', {
  categories: [activityCategory],
});

export default challengeTemplateSchema;
